const debounce = (callback, wait) => {
  let timeoutId = null;
  return (...args) => {
      window.clearTimeout(timeoutId);
      timeoutId = window.setTimeout(() => {
      callback.apply(null, args);
      }, wait);
  };
}

function trapFocus(modal) {
  const focusableSelectors = `
    a[href], area[href], input:not([disabled]),
    select:not([disabled]), textarea:not([disabled]),
    button:not([disabled]), [tabindex]:not([tabindex="-1"])`;
  const focusableElements = Array.from(modal.querySelectorAll(focusableSelectors));

  if (focusableElements.length === 0) {
    console.warn('No focusable elements found in the modal.');
    return;
  }

  const firstFocusableElement = focusableElements[0];
  const lastFocusableElement = focusableElements[focusableElements.length - 1];

  function handleFocusTrap(event) {
    const isTabPressed = event.key === 'Tab';

    if (!isTabPressed) return;
    if (event.shiftKey) {
      if (document.activeElement === firstFocusableElement) {
        lastFocusableElement.focus();
        event.preventDefault();
      }
    } else {
      if (document.activeElement === lastFocusableElement) {
        firstFocusableElement.focus();
        event.preventDefault();
      }
    }
  }
  modal.addEventListener('keydown', handleFocusTrap);
  firstFocusableElement.focus();
  firstFocusableElement.blur();
  
  return function cleanupFocusTrap() {
    modal.removeEventListener('keydown', handleFocusTrap);
  };
}



const addToCart = async (productForm) => {
  const formData = new FormData(productForm);    
  formData.append('sections', 'inner-cart');
  
  const cart = fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    body: formData
  })
    .then((response) => response.json())
    .then((json) => json)
    .catch((err) => console.error(err));
    
  return cart;
}

const updateQty = async (id, qty) => {
  const updates = {};
  updates[id] = qty;

  const data = {
    updates,
    sections: ['inner-cart'],
  };

  const cart = fetch('/cart/update.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.error('Error:', error);
    });

  return cart;
};

// small scroll to section function
document.addEventListener('click', (event) => {
  const scrollTrigger = event.target.closest('[data-scroll-to]');
  if (scrollTrigger) {
    const scrollTarget = scrollTrigger.getAttribute('data-scroll-to');
    const targetElement = document.getElementById(scrollTarget);
    if (targetElement) {
      event.preventDefault();
      targetElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  }
});

window.addEventListener('submit', (e) => {
  const productForm = e.target.closest(`[action="${Shopify.routes.root}cart/add"]`);
  if(!productForm) return;
  e.preventDefault();

  window.dispatchEvent(new CustomEvent('modal:openById', { 
    detail: 'minicart'
  }));
  
  const minicart = document.querySelector('mini-cart');
  if (minicart) minicart.classList.add('loading');
  
  addToCart(productForm)
    .then((cart) => {
      window.dispatchEvent(new CustomEvent('productForm:add', { 
        detail: cart
      }));
      
      if (!minicart) return;
      minicart.classList.remove('loading');
    })
    .catch(err => {
      alert(`Unable to add the product to cart. Please refresh and try again. Error: ${err}`)
    })
});